<app-plate-search></app-plate-search>

<app-vehicle-label></app-vehicle-label>

<app-table-wizard *ngIf="vehicleInfo && vehicleInfo.versions.length > 1"></app-table-wizard>

<app-table-versions *ngIf="vehicleInfo && vehicleInfo.versions.length > 1"></app-table-versions>

